<template>
  <div style="position: relative;">
    <el-form ref="technologyTrainFlowList" :model="technologyTrainFlowList" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="technologyTrainFlowList.formFilter.flowStatus" :clearable="true"
            placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
              :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="technologyTrainFlowList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="technologyTrainFlowList.formFilter.workOrderCode"
            :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <el-form-item label="主题" prop="formFilter.queryForm.trainSubject">
          <el-input class="filter-item" v-model="technologyTrainFlowList.formFilter.queryForm.trainSubject"
            :clearable="true" placeholder="主题"
          />
        </el-form-item>
        <el-form-item label="创建人" prop="formFilter.queryForm.specialistName">
          <el-input class="filter-item" v-model="technologyTrainFlowList.formFilter.queryForm.specialistName"
                    :clearable="true" placeholder="创建人名称"
          />
        </el-form-item>
        <el-form-item label="流程状态" prop="formFilter.latestApprovalStatus">
          <el-select class="filter-item" v-model="technologyTrainFlowList.formFilter.latestApprovalStatus"
                     :clearable="true" filterable
                     placeholder="" :loading="technologyTrainFlowList.latestApprovalStatus.impl.loading"
                     @visible-change="technologyTrainFlowList.latestApprovalStatus.impl.onVisibleChange"
          >
            <el-option v-for="item in technologyTrainFlowList.latestApprovalStatus.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTechnologyTrainFlowList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize"
                   @click="onStartTaskClick()">
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-table ref="technologyTrain"
      :data="technologyTrainWidget.dataList"
      :size="defaultFormItemSize"
      @sort-change="technologyTrainWidget.onSortChange"
      header-cell-class-name="table-header-gray"
    >

      <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
                       :index="technologyTrainWidget.getTableIndex"
      />
      <el-table-column label="工单编号" prop="workOrderCode" />
      <el-table-column label="创建人" prop="masterData.specialistName" />
      <el-table-column label="创建时间" prop="masterData.createTime">
        <template slot-scope="scope">
          <span>{{formatDateByStatsType(scope.row.masterData.createTime, 'day')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="主题" prop="masterData.trainSubject" />
      <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
      <el-table-column label="流程创建时间" prop="createTime" />
      <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
      <el-table-column label="工单状态" prop="flowStatus"  width="100px">
        <template slot-scope="scope">
          <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" :size="defaultFormItemSize"
            v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
            @click.stop="onViewTaskClick(scope.row)">
            详情
          </el-button>
          <el-button type="text" :size="defaultFormItemSize"
            v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey"
            @click.stop="onHandlerTaskClick(scope.row)">
            办理
          </el-button>
          <el-button type="text" :size="defaultFormItemSize" class="table-btn"
            @click.stop="onRemindClick(scope.row)">
            催办
          </el-button>
          <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
            @click.stop="onCancelTaskClick(scope.row)">
            撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" style="margin-top: 10px;">
      <el-pagination
        :total="technologyTrainWidget.totalCount"
        :current-page="technologyTrainWidget.currentPage"
        :page-size="technologyTrainWidget.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, prev, pager, next, sizes"
        @current-change="technologyTrainWidget.onCurrentPageChange"
        @size-change="technologyTrainWidget.onPageSizeChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { TechnologyTrainController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'technologyTrainFlow';
const processDefinitionName = '科技培训';

export default {
  name: 'technologyTrainFlowList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      technologyTrainFlowList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          queryForm: {specialistName: undefined}
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          queryForm: {specialistName: undefined}
        },
        latestApprovalStatus: {
          impl: new DropdownWidget(this.loadLatestApprovalStatusDropdownList)
        },
        isInit: false
      },
      technologyTrainWidget: new TableWidget(this.loadTechnologyTrainData, this.loadTechnologyTrainVerify, false)
    }
  },
  methods: {
    onReset () {
      this.$refs.technologyTrainFlowList.resetFields();
      this.refreshTechnologyTrainFlowList(true);
    },
    loadTechnologyTrainData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.technologyTrainFlowList.formFilterCopy.flowStatus,
          queryForm: this.technologyTrainFlowList.formFilterCopy.queryForm,
          workOrderCode: this.technologyTrainFlowList.formFilterCopy.workOrderCode,
          latestApprovalStatus: this.technologyTrainFlowList.formFilterCopy.latestApprovalStatus,
          createTimeStart: Array.isArray(this.technologyTrainFlowList.formFilterCopy.createTime) ? this.technologyTrainFlowList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.technologyTrainFlowList.formFilterCopy.createTime) ? this.technologyTrainFlowList.formFilterCopy.createTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        TechnologyTrainController.listWorkOrderTechnologyTrainFlow(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadTechnologyTrainVerify () {
      this.technologyTrainFlowList.formFilterCopy.flowStatus = this.technologyTrainFlowList.formFilter.flowStatus;
      this.technologyTrainFlowList.formFilterCopy.workOrderCode = this.technologyTrainFlowList.formFilter.workOrderCode;
      this.technologyTrainFlowList.formFilterCopy.createTime = this.technologyTrainFlowList.formFilter.createTime;
      this.technologyTrainFlowList.formFilterCopy.queryForm = this.technologyTrainFlowList.formFilter.queryForm;
      this.technologyTrainFlowList.formFilterCopy.latestApprovalStatus = this.technologyTrainFlowList.formFilter.latestApprovalStatus;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          console.log(res.data.routerName || 'handlerFlowTask')
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.refreshTechnologyTrainFlowList();
        }).catch(e => {});
      }).catch(e => {});
    },
    loadLatestApprovalStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysLatestApprovalStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 刷新工单
    refreshTechnologyTrainFlowList (reloadData = false) {
      if (reloadData) {
        this.technologyTrainWidget.refreshTable(true, 1);
      } else {
        this.technologyTrainWidget.refreshTable();
      }
      if (!this.technologyTrainFlowList.isInit) {
        // 初始化下拉数据
      }
      this.technologyTrainFlowList.isInit = true;
    },
    onResume () {
      this.refreshTechnologyTrainFlowList();
    },
    formInit () {
      this.refreshTechnologyTrainFlowList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style>
</style>
